import React from "react";
import {
  Box,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const AndriodSwitchWithIcon = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Switch with Icons
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          switch thumb inside switch track. with icons.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"switch primary with icons"}
          language={"js"}
          value={
            "           <FormControlLabel\n" +
            "              control={\n" +
            "                <Switch\n" +
            '                  variant={"withIcon"}\n' +
            '                  color={"primary"}\n' +
            "                  defaultChecked\n" +
            "                />\n" +
            "              }\n" +
            '              label="Available Icon (Medium)"\n' +
            "            />\n\n\n" +
            "            <FormControlLabel\n" +
            "              control={\n" +
            "                <Switch\n" +
            '                  variant={"withIcon"}\n' +
            '                  color={"primary"}\n' +
            '                  size={"small"}\n' +
            "                  defaultChecked\n" +
            "                />\n" +
            "              }\n" +
            '              label="Available Icon (Small)"\n' +
            "            />"
          }
        >
          <Stack spacing={2}>
            <FormControlLabel
              control={
                <Switch variant={"withIcon"} color={"primary"} defaultChecked />
              }
              label="Available Icon (Medium)"
            />
            <FormControlLabel
              control={
                <Switch
                  variant={"withIcon"}
                  color={"primary"}
                  size={"small"}
                  defaultChecked
                />
              }
              label="Available Icon (Small)"
            />
          </Stack>
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default AndriodSwitchWithIcon;
